import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Container , Row , Button,Card, Col } from 'react-bootstrap';
import { LoginManager } from '../core/login-manager';
import { TicketFiltersBar, fetchTicket } from './utils/ticket/ticketFetching.js';
import { Link } from 'react-router-dom';

import { DonutChart , GroupedBarChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

import {
    QueryClient,
    useQuery
} from '@tanstack/react-query';

import { entity_language } from './entity_language.js';
import { DataManager } from '../core/data-manager.js';
import { ApiManager } from '../core/api-manager.js';
import TicketMap from './pages/ticketMap/TicketMap.js';

import getPhotoUrl from './utils/getPhotoUrl/getPhotoUrl.ts';
import { settings } from './settings.js';


  

export default function Dashboard() {

    console.log('version 6.0.0');

    const queryClient = new QueryClient();

    const [errors, setErrors] = useState('');

    const [statusFilters, setStatusFilters] = useState('all');
    const now = new Date();
    const fromDate = new Date(now);
    fromDate.setDate(now.getDate() - 365);
    const toDate = new Date(now);
    toDate.setDate(now.getDate() + 1);
    const [fromDateFilters, setFromDateFilters] = useState(fromDate.toISOString().split('T')[0]);
    const [toDateFilters, setToDateFilters] = useState(toDate.toISOString().split('T')[0]);

    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {idUserGroup: 0};

    console.log('queryKey', ['ticket', 'idUserGroup' + userInfo?.idUserGroup, statusFilters , {'fromDate': fromDateFilters , 'toDate': toDateFilters}]);

    /* const data = {};
    const isLoading = false;
    const isError = false;
    const isSuccess = false;

    const authorityData = {
                data : {},
        isLoading : false,
        isError : false,
        isSuccess : false
    }; */

    const {data , isLoading, isError, isSuccess } = useQuery({
        queryKey: [
            'ticket',
            { userGroup: userInfo?.idUserGroup },
            { status: statusFilters },
            { fromDate: fromDateFilters },
            { toDate: toDateFilters }
          ],
        queryFn: () => fetchTicket({ 
            queryFilters: { 
                status: statusFilters, 
                fromDate: fromDateFilters,
                toDate: toDateFilters
            } 
        }),
        keepPreviousData: true,
        },queryClient);

    console.log('fetchTicketResponse', data);

    const authorityData = useQuery({
        queryKey: ['user_group', 'idUserGroup' + userInfo?.idUserGroup],
        queryFn: () => ApiManager.sendAuthenticatedRequest('/custom/get_ticket_report', {}),
        keepPreviousData: true
        },queryClient);

    console.log('fetchAuthorityData', authorityData.data);


    useEffect(() => {
        console.log('data fetched', data);
    }, [data]);

    return (
        <>
        <Container fluid>
            <TicketFiltersBar 
                showResults={false}
                data={data}
                isLoading={isLoading}
                fromDateFilters={fromDateFilters}
                setFromDateFilters={setFromDateFilters}
                toDateFilters={toDateFilters}
                setToDateFilters={setToDateFilters}
                statusFilters={statusFilters}
                setStatusFilters={setStatusFilters}
            />
            <Container className='d-flex justify-content-center align-items-start flex-column flex-lg-row-reverse gap-4 mb-5 p-0'>

                <AuthorityCards authorityRawData={authorityData.data} />
                <Col sm lg="8">
                    <Row  className='gap-4'>
                        <TicketPeriodView rawData={data} fromDateFilters={fromDateFilters} toDateFilters={toDateFilters}  />
                        <ComparisonStates rawData={data} />
                        <ComparisonCategories rawData={data} />
                        {/* <CardTicketMap data={data} fromDate={fromDateFilters} toDats={toDateFilters} status={statusFilters} /> */}
                    </Row>
                </Col>
            </Container>
        </Container>
        </>
    )
};

export function TicketPeriodView({rawData , fromDateFilters , toDateFilters}) {

    const [ticketPeriodView, setTicketPeriodView] = useState([]);
    const [periodView , setPeriodView] = useState( {period:'mounth' , label: 'Mese'});

    useEffect(() => {
        if (!fromDateFilters || !toDateFilters) return;
    
        let startDate = moment(fromDateFilters);
        let endDate = moment(toDateFilters);
    
        if (startDate.isAfter(endDate)) {
            [startDate, endDate] = [endDate, startDate];
        }
    
        const monthDiff = Math.abs(startDate.diff(endDate, 'months', true));
        console.log('monthDiff', monthDiff);
        console.log('monthDiff',  monthDiff < 1);
        const newPeriod = monthDiff < 1 ? { period: 'week', label: 'Settimane' } : { period: 'month', label: 'Mese' };
    
        // Only set if it actually changed
        if (newPeriod.period !== periodView.period) {
            setPeriodView(newPeriod);
        }
        console.log('periodView', periodView);
        setTicketPeriodView(extractTicketPeriodView(rawData?.body , fromDateFilters , toDateFilters , periodView.period));
    }, [rawData , fromDateFilters , toDateFilters]);

    return (
        <Container>
            <Card className='p-4'>
                <h4 className='position-absolute'>Segnalazioni per {periodView.label}</h4>
                <GroupedBarChart 
                    data={ticketPeriodView}
                    options={{
                        axes: {
                            left: {
                                mapsTo: 'value',
                            },
                            bottom: {
                                mapsTo: 'date',
                                scaleType: 'time',
                            }
                        },
                        data: {
                            groupMapsTo: 'status',
                        },
                        bars: {
                            maxWidth: 20,
                            width: 10
                        },
                        height: '400px',
                    }}
                ></GroupedBarChart>
            </Card>
        </Container>
    )
}

export function ComparisonStates({rawData}) {

    const [ticketCompareStatus, setTicketCompareStatus] = useState([]);

    useEffect(() => {
        console.log('rawDataComparisonStates', rawData);
        setTicketCompareStatus(extractTicketStatus(rawData?.body));
    }, [rawData]);


    console.log('ticketCompareStatus', ticketCompareStatus);
    return (
        <Container>
            <Card className='p-4'>
                <h4 className='position-absolute'>Rapporto segnalazioni</h4>
                <DonutChart 
                    data={ticketCompareStatus}
                    options={{
                        resizable: true,
                        legend: {
                            alignment: 'center'
                        },
                        donut: {
                            center: {
                            label: 'Segnalazioni'
                            },
                            alignment: 'center'
                        },
                        color: {
                            scale: {
                                'Aperta': '#dc3545',
                                'In Gestione': '#ffc107',
                                'Chiusa': '#198754',
                            },
                        }
                    }}
                ></DonutChart>

            </Card>
        </Container>
    )
}

export function ComparisonCategories({rawData}) {

    const [ticketCompareCategories , setTicketCompareCategories] = useState([]);

    useEffect(() => {
        (async () => {
            setTicketCompareCategories( await extractTicketCategories(rawData?.body));
        })();
    }, [rawData]);

    return (
        <Container>
            <Card className='p-4'>
                <h4 className='position-absolute'>Rapporto categorie</h4>
                <DonutChart 
                    data={ticketCompareCategories}
                    options={{
                        resizable: true,
                        legend: {
                            alignment: 'center'
                        },
                        donut: {
                            center: {
                            label: ''
                            },
                            alignment: 'center'
                        },
                        height: '400px',
                    }}
                ></DonutChart>

            </Card>
        </Container>
    )
}

export function CardTicketMap({data , fromDate , toDate , status}) {

    const [selectedFilters , setSelectedFilters] = useState({
        'status' : status,
        'fromDate' : fromDate,
        'toDate' : toDate
    })
    const selectedFiltersString = JSON.stringify(selectedFilters);

    useEffect(() => {
        setSelectedFilters({
            'status' : status,
            'fromDate' : fromDate,
            'toDate' : toDate
        })
    }, [data]);

    return (
        <Container>
            <Card className='p-4'>
                <Container className='mb-3'>
                    <Row>
                        <Col>
                            <h4>Segnalazioni sulla mappa</h4>
                        </Col>
                        <Col className='d-flex justify-content-end'>
                            <Button variant="outline-primary" to={`/page/ticketMap?${new URLSearchParams(selectedFiltersString).toString()}`} as={Link} >
                                Visualizza su Mappa
                            </Button>
                        </Col>
                    </Row>
                </Container>
                <TicketMap data={data} options={{scrollWheelZoom: false}} />
            </Card>
        </Container>
    )
}

export function AuthorityCards({authorityRawData}) {

    const userInfo = LoginManager.getUserInfo()

    return (
        <Container className='d-flex flex-column gap-4'>
            <Card className='p-4 gap-4'>
                <Row className='d-flex align-items-center justify-content-start gap-4'>
                    <Col xs='auto' className='w-auto d-flex align-items-center justify-content-start'>
                        <img 
                            src={getPhotoUrl(authorityRawData?.authority_info?.logo?.entity , authorityRawData?.authority_info?.logo?.hash , authorityRawData?.authority_info?.logo?.extension)} 
                            alt={`Logo ${authorityRawData?.authority_info?.name}`} 
                            style={{ width: '100px', height: 'auto' , objectFit: 'cover' ,aspectRatio: '1/1' , borderRadius: '9999px' , border: '1px solid rgba(var(--bs-secondary-rgb), 1)' }} />
                    </Col>
                </Row>
                <Row className='d-flex align-items-center justify-content-start gap-4'>
                    <Col className='w-auto d-flex align-items-center justify-content-start'>
                        <h4 className='m-0'>{authorityRawData?.authority_info?.name || userInfo.name}</h4>
                    </Col>
                </Row>
                <Row>
                    {(
                        () => {
                            if(authorityRawData?.authority_info?.date) {
                                return (
                                    <p>Attivo da: {moment(authorityRawData?.authority_info?.date).format('DD/MM/YYYY')}</p>
                                )
                            }
                            if(authorityRawData?.authority_info?.expireDate) {
                                return (
                                    <p>Prossimo rinnovo: { moment(authorityRawData?.authority_info?.expireDate).format('DD/MM/YYYY')  }</p>
                                )
                            }
                        }
                    )()}
                </Row>
                <Row>
                    <Col sx='auto'>
                        <Button variant="outline-secondary" to={settings.supportLink || '#'} as={Link} className='w-100' target="_blank" rel="noopener noreferrer">
                            Supporto
                        </Button>
                    </Col>
                </Row>
            </Card>

            {(
                () => {
                    if( authorityRawData?.ticket_author_count > 0) {
                        return (
                            <Card className='p-4 gap-4'>
                                <Row className='m-0 p-0'>
                                    <Col xs='auto' className='w-auto d-flex align-items-center justify-content-start'>
                                        <h2 className='m-0'>{authorityRawData?.ticket_author_count}</h2>    
                                    </Col>
                                    <Col>
                                        <h6 className='m-0 p-0'>Segnalatori Totali</h6>
                                        <p className='small m-0 p-0 fw-lighter'>Conteggio da data d'iscrizione</p>
                                    </Col>
                                </Row>
                            </Card>
                        )
                    }
                }
            )()}

            {(
                () => {
                    if( authorityRawData?.total_tickets > 0 ) {
                        return (
                            <Card className='p-4 gap-4'>
                                <Row className='m-0 p-0'>
                                    <Col xs='auto' className='w-auto d-flex align-items-center justify-content-start'>
                                        <h2 className='m-0'>{authorityRawData?.total_tickets}</h2>    
                                    </Col>
                                    <Col>
                                        <h6 className='m-0 p-0'>Totale segnalazioni</h6>
                                        <p className='small m-0 p-0 fw-lighter'>Conteggio da data d'iscrizione</p>
                                    </Col>
                                </Row>
                            </Card>
                        )
                    }
                }
            )()}

            {( () => {
                if( authorityRawData?.ticket_category_count && authorityRawData?.ticket_category_count?.length > 0 ){
                    return (
                        <Card className='p-4 gap-4'>
                                <Row className='m-0 p-0'>
                                    <h6 className='m-0 p-0 fw-600'>Suddivisione in categorie</h6>
                                    <p className='small m-0 p-0 fw-lighter'>Conteggio da data d'iscrizione</p>

                                    <ul className='m-0 p-0'>
                                        {( ()=> authorityRawData?.ticket_category_count.sort(
                                            (a, b) => {
                                                return b.countTicket - a.countTicket;
                                            }
                                        ).map( category => {
                                                console.log('loop category' , category);
                                                return (
                                                    <li className='m-0 p-0 d-flex align-items-center justify-content-start list-style-type-none gap-4 mt-4' key={category?.idCategory}>   
                                                        <Col xs='auto' className='w-auto d-flex align-items-center justify-content-start'>
                                                            <img src={getPhotoUrl( category?.entityIconCategory , category?.hashIconCategory , category?.extIconCategory )} className='m-0' style={{ width: '65px', height: 'auto' , objectFit: 'cover' , aspectRatio: '1/1' , borderRadius: '9999px' , border: '1px solid rgba(var(--bs-secondary-rgb), 1)' }} />    
                                                        </Col>
                                                        <Col xs='auto' className='w-auto d-flex flex-column align-items-start justify-content-start gap-2'>
                                                            <h3 className='fs-6 m-0'>{category?.titleCategory}</h3>
                                                            <h2 className='fs-5 m-0'>{category?.countTicket || 0} <span className='fw-light fs-6'>Segnalazioni</span></h2>    
                                                        </Col>
                                                    </li>
                                                )
                                            })
                                        )()}
                                    </ul>
                                </Row>
                        </Card>
                    )
                }
            })()}


            

        </Container>
    )
}



export function extractTicketPeriodView(data , fromDateFilters , toDateFilters , period) {

    if(!data) return [];
    if(!fromDateFilters) return [];
    if(!toDateFilters) return [];
    if(!period) return [];

    const fromDate = moment(fromDateFilters).startOf(period);
    const toDate = moment(toDateFilters).endOf(period);
    
    let output = [];

    //get every month between fromDate and toDate
    let currentDate = fromDate;

    for ( let i = 0;  currentDate <= toDate ; currentDate.add(1, period) ) {

        let ticketCount = Object.values(data).filter( item => {
            const insertDate = moment(item.date);
            if (moment(insertDate).isBetween(currentDate, currentDate.clone().endOf(period), null, '[]')) {
                return item;
            }
        }).length || 0;

        output.push({
            date: currentDate.startOf(period).format(),
            value: ticketCount,
            status: 'Nuove segnalazioni'
        });

    }
    console.log('extractTicketMouthView', output);
    return output;
}

export function extractTicketStatus(data) {

    if(!data) return [];

    let output = {
        '5_OPEN': {
            value: 0,
            group: entity_language.labels.ticket['status.options.5_OPEN']
        },
        '10_IN_PROGRESS': {
            value: 0,
            group: entity_language.labels.ticket['status.options.10_IN_PROGRESS']
        },
        '15_CLOSED': {
            value: 0,
            group: entity_language.labels.ticket['status.options.15_CLOSED']
        }
    };

    const acceptedStatus = ['5_OPEN', '10_IN_PROGRESS', '15_CLOSED'];

    acceptedStatus.map( status => {
        let ticketCount = Object.values(data).filter( item => {
            if(item.status.value === status){
                return item;
            }
        }).length || 0;

        output[status].value = ticketCount;
    });

    console.log('extractTicketStatus', JSON.stringify(Object.values(output)));
    return Object.values(output);
}

export async function extractTicketCategories(data) {

    if(!data) return [];

    let allCategories = [];
    const response = await DataManager.getItems('category', 1, 9999999, { 'field': 'title', 'order': 'DESC' });

    if(response && response?.success && response?.body) {
        response.body?.map( item => {
            allCategories.push(item?.title);
        });
    }else{
        return [];
    }

    let output = [];

    allCategories.map( category => {
        let ticketCount = data.filter( item => {
            if(item?.idCategory?.title === category){
                return item;
            }
        }).length || 0;

        output.push({
                value: ticketCount,
                group: category
        });
    });

    console.log('extractTicketCategories', JSON.stringify(output));

    return output;
}

